/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResourceFilterName } from './ResourceFilterName';
import {
    ResourceFilterNameFromJSON,
    ResourceFilterNameFromJSONTyped,
    ResourceFilterNameToJSON,
    ResourceFilterNameToJSONTyped,
} from './ResourceFilterName';

/**
 * 
 * @export
 * @interface AnonRequestFilter
 */
export interface AnonRequestFilter {
    /**
     * 
     * @type {number}
     * @memberof AnonRequestFilter
     */
    id?: number;
    /**
     * 
     * @type {ResourceFilterName}
     * @memberof AnonRequestFilter
     */
    name?: ResourceFilterName;
    /**
     * comma separated list | single value | range a-b
     * @type {string}
     * @memberof AnonRequestFilter
     */
    filter?: string;
}



/**
 * Check if a given object implements the AnonRequestFilter interface.
 */
export function instanceOfAnonRequestFilter(value: object): value is AnonRequestFilter {
    return true;
}

export function AnonRequestFilterFromJSON(json: any): AnonRequestFilter {
    return AnonRequestFilterFromJSONTyped(json, false);
}

export function AnonRequestFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnonRequestFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : ResourceFilterNameFromJSON(json['name']),
        'filter': json['filter'] == null ? undefined : json['filter'],
    };
}

export function AnonRequestFilterToJSON(json: any): AnonRequestFilter {
    return AnonRequestFilterToJSONTyped(json, false);
}

export function AnonRequestFilterToJSONTyped(value?: AnonRequestFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': ResourceFilterNameToJSON(value['name']),
        'filter': value['filter'],
    };
}

